/** Line-art phone + bell + checkmark for the notifications onboarding slide. */
export function NotificationsIllustration() {
  const phoneStroke = "oklch(92% 0.02 150)";
  const bellStroke = "oklch(78% 0.12 85)";
  const checkFill = "oklch(72% 0.09 155)";

  return (
    <svg
      viewBox="0 0 240 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="mx-auto h-auto w-full max-w-[220px] sm:max-w-[240px]"
      aria-hidden
    >
      <g transform="rotate(-10 120 140)">
        <rect
          x="66"
          y="20"
          width="108"
          height="222"
          rx="24"
          stroke={phoneStroke}
          strokeWidth="2.5"
        />
        <rect
          x="106"
          y="32"
          width="28"
          height="8"
          rx="4"
          stroke={phoneStroke}
          strokeWidth="1.75"
        />
        <line
          x1="100"
          y1="228"
          x2="140"
          y2="228"
          stroke={phoneStroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeOpacity="0.7"
        />

        <path
          d="M120 98c-8.8 0-16 7.2-16 16v4.2c0 2.8-1.1 5.5-3.1 7.5l-2.4 2.4c-.8.8-.3 2.2.9 2.2h40.3c1.2 0 1.7-1.4.9-2.2l-2.4-2.4a10.6 10.6 0 0 1-3.1-7.5V114c0-8.8-7.2-16-16-16Z"
          stroke={bellStroke}
          strokeWidth="2.25"
          strokeLinejoin="round"
        />
        <path
          d="M110 134h20"
          stroke={bellStroke}
          strokeWidth="2.25"
          strokeLinecap="round"
        />
        <path
          d="M114 138c0 3.3 2.7 6 6 6s6-2.7 6-6"
          stroke={bellStroke}
          strokeWidth="2.25"
          strokeLinecap="round"
        />

        <circle cx="158" cy="118" r="14" fill={checkFill} />
        <path
          d="M151.5 118l4.5 4.5 9-9"
          stroke={phoneStroke}
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
